import type { ChequeBcraIngreso } from '../../../types/bcraCentralDeudores';

export interface ChequesTerceroFiltrosStored {
  searchTerm?: string;
  rowsPerPage?: number;
  nroBanco?: string;
  bancoNombre?: string;
  nroSucursal?: string;
  fechaIngresoDesde?: string;
  fechaIngresoHasta?: string;
  fechaSalidaDesde?: string;
  fechaSalidaHasta?: string;
  fechaVencimientoDesde?: string;
  fechaVencimientoHasta?: string;
  importeDesde?: string;
  importeHasta?: string;
  mcp?: string;
  estado?: string;
  nroCliente?: number | '';
  nombreCliente?: string;
  nroProveedor?: number | '';
  nombreProveedor?: string;
  nroBancoDeposito?: string;
  bancoDepositoNombre?: string;
  nroCuentaDeposito?: string;
  vencimientoRapido?: string;
  vistaCompacta?: boolean;
  /** '' | 'fisicos' | 'electronico' */
  filtroTipoSoporte?: string;
}

export interface ChequeTercero {
  nroCarga: number;
  nroBanco: number;
  nombreBanco: string;
  nroSucursal: number;
  nombreSucursal: string;
  nroCheque: number;
  nroLibrador: string;
  librador: string;
  importe: number;
  fechaIngreso: string;
  nroMovCajaIngre: number | null;
  nroDestino: number | null;
  fechaSalida: string | null;
  nroMovCajaSalida: number | null;
  fechaVencimiento: string;
  concepto: string;
  fechaEmision: string;
  conciliado: number;
  asentado: number;
  mcp: string;
  nroCuenta: string;
  senial?: number;
  comprobanteIngreso?: string;
  comprobanteSalida?: string;
  rechazado?: number;
  fechaRechazo?: string | null;
  nroCliente?: number | null;
  nombreCliente?: string | null;
  nroProveedor?: number | null;
  nombreProveedor?: string | null;
  nroBancoDeposito?: number | null;
  nombreBancoDeposito?: string | null;
  nroCuentaDeposito?: number | null;
  bcraIngreso?: ChequeBcraIngreso | null;
  /** true = electrónico; false = físico. */
  esElectronico?: boolean;
}

export type FiltroTipoSoporteCheque = '' | 'fisicos' | 'electronico';

export interface ChequesTerceroResumen {
  totalCount: number;
  totalImporte: number;
  enCarteraCount: number;
  vencenEsteMesCount: number;
}

export interface BancoOption {
  id: number;
  nombre: string;
  nroBanco?: string | number;
}

export interface SucursalBanco {
  nroBanco: number;
  nroSucursal: number;
  sucursal: string;
}

export interface McpOption {
  mcp: string;
  descripcion?: string;
}

export type VencimientoRapido = '' | 'este_mes' | 'vencidos' | 'proximos_7';

export const VISTA_COMPACTA_STORAGE_KEY = 'tesoreria.cheques-tercero.vistaCompacta';
